import { Injectable } from '@angular/core';

import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

@Injectable()
export class MultiReturnsMessageTrackingService {
    constructor(private trackingService: TrackingService) {}

    trackClick(): void {
        this.trackingService.triggerEventWithCleaning(trackingConstants.EVENT_FUNC_BETS, {
            [trackingConstants.PAGE_REFERRING_ACTION]: 'Multi_Returns_Massage_Click',
        });
    }
}
